"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'DetailHeader',
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 图标 class
    icon: {
      type: String,
      default: ''
    },
    // 单号
    orderNo: {
      type: [String, Number],
      default: ''
    },
    // 单号标签
    titleLable: {
      type: String,
      default: ''
    },
    colClass: {
      //样式
      type: String,
      default: ''
    },
    // 底部列表 [{label: '', value: '', color: ''}]
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};